import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import IntlMessage from '../../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export default function ModalLocalizacao(props) {
  const [modalAberto, setModalAberto] = useState(false);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const [locaisAnteriores, setlocaisAnteriores] = useState([]);
  const [localSelecionado, setLocalSelecionado] = useState({});
  const dispatch = useDispatch();
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

  useEffect(() => {
    setModalAberto(props.showModalLocalizacao);
    dispatch(commonActions.showModal(props.showModalLocalizacao));
  }, [props.showModalLocalizacao]);

  useEffect(() => {
    setLocalSelecionado({});
    const lista = props.locaisAnteriores.map(x => ({
      value: x,
      label: x
    }));
    setlocaisAnteriores(lista);
  }, [props.locaisAnteriores]);

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-confirm'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <IntlMessage id="general.materialArchiving.confirmationManualArchiving" />
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.materialArchiving.reason" />:</Label>
                  <Input
                    placeholder={translate("general.materialArchiving.informTheReason")}
                    value={props.motivoArquivamento}
                    onChange={e => props.setMotivoArquivamento(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.materialArchiving.location" />:</Label>
                  <SelectCreatableComponent
                    onChange={e => {
                      e && e.label && props.setLocalizacaoArquivamento(e.label);
                      setLocalSelecionado(e);
                    }}
                    onCreateOption={e => {
                      setLocalSelecionado({ label: e, value: e });
                      setlocaisAnteriores([
                        { label: e, value: e },
                        ...locaisAnteriores
                      ]);
                      props.setLocalizacaoArquivamento(e);
                    }}
                    options={locaisAnteriores}
                    placeholder={translate("general.materialArchiving.previousLocations")}
                    label={<IntlMessage id="general.materialArchiving.registerNewLocation" />}
                    value={localSelecionado}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.materialArchiving.close" />
            </Button>
            <Button
              className={`button-confirm`}
              onClick={props.salvar}
              color='primary'
              disabled={!props.localizacaoArquivamento}
            >
              <IntlMessage id="general.materialArchiving.toFile" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/ArquivamentoManual/Localizacao/index.js